import React, { useContext } from 'react';
import { AuthContext } from '../../../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import RegisterForm from '../../../components/UI/Form/RegisterForm';
import { useContentfulContext } from '../../../contexts/ContentfulContext';

// const PWD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%]).{8,60}$/;
// const EMAIL_REGEX = /\S+@\S+\.\S+/;
// const NAME_REGEX = /^[a-zA-z\s].{2,60}$/;

const Register = () => {
    const { setAuth } = useContext(AuthContext);
    const { content } = useContentfulContext();
    const navigate = useNavigate();

    return (
        <section>
            <div className="mx-auto flex flex-col md:flex-row items-center max-w-[75%] my-12">
                <div className="p-8 flex flex-col lg:w-1/2 justify-center items-start">
                    <div className="space-y-4 md:space-y-6 w-full">
                        <h1 className="text-xl font-medium leading-tight tracking-tight text-gray-900 md:text-2xl text-center">
                            {content.REGISTRATION_CONTENT.title}
                        </h1>
                        <RegisterForm submitHandler={(values) => {
                            setAuth(values);
                            navigate('/auth/verification');
                        }} />
                    </div>
                </div>
                <div className="p-8 lg:w-1/2">
                    <div className="h-48 flex flex-wrap content-center">
                        <div>
                            <img src={content.REGISTRATION_CONTENT.image_url} alt="" />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Register;